var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 5.0625H3.5625C2.73407 5.0625 2.0625 5.73407 2.0625 6.5625V13.6875C2.0625 14.5159 2.73407 15.1875 3.5625 15.1875H14.4375C15.2659 15.1875 15.9375 14.5159 15.9375 13.6875V6.5625C15.9375 5.73407 15.2659 5.0625 14.4375 5.0625H12.1875M5.8125 5.0625V3.5625C5.8125 2.73407 6.48407 2.0625 7.3125 2.0625H10.6875C11.5159 2.0625 12.1875 2.73407 12.1875 3.5625V5.0625M5.8125 5.0625H12.1875",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.0dd04e938412b98b4b2bd468cdbbb396.svg";
export { ForwardRef as ReactComponent };